import '../../inventory/grn/grnDetail.css';
import { Table, Modal, Col, Row } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { get } from '../../../services/apiController';
import { DownloadIcon } from '../../icons';

const AdsDetail = ({ view, onClose, adId }) => {
  const [details, setDetails] = useState({});
  useEffect(() => {
    if (adId) {
      get('/ks-ads/' + adId).then((data) => {
        setDetails(data.data);
      });
    }
  }, []);

  return (
    <Modal size="xl" show={view} backdrop="static" keyboard={false} className="request-modal">
      <Modal.Header>
        <Modal.Title>Advertisement Details</Modal.Title>
        <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
      </Modal.Header>
      <Modal.Body>
        <div className={`grn-detail`}>
          <div className="text-center">
            <div className="mb-3">
              <h4 className="m-0 mb-2">Kanti Sweets Private Limited</h4>
            </div>
            <div>
              <h5 className="mb-2">
                <b>
                  <u>Advertisement Details</u>
                </b>
              </h5>
            </div>
          </div>
          <Table bordered striped responsive className="mt-3">
            <tbody>
              <tr>
                <th>Title</th>
                <td>{details?.title}</td>
                <th>Status</th>
                <td>{details?.status}</td>
                <th>File Type</th>
                <td>{details?.fileType}</td>
              </tr>
            </tbody>
          </Table>
          {details.file ? (
            <>
              <div className="text-left">
                <div>
                  <h6 className="mb-2">
                    <b>{`Advertisement ${details.fileType}`}</b>
                  </h6>
                </div>
              </div>
              <Row>
                {details.file ? (
                  <>
                    <Col xs={3} className="file-name">
                      {details?.file}
                    </Col>
                    <Col xs={1} className="text-center actions">
                      <a href={`${process.env.REACT_APP_DIGITAL_OCEAN_URL}/${details?.file}`}>
                        <DownloadIcon />
                      </a>
                    </Col>
                  </>
                ) : (
                  ''
                )}
              </Row>
            </>
          ) : (
            ''
          )}
          {details.fileType === 'image' && (
            <>
              <div className="text-left">
                <div>
                  <h6 className="mb-2 mt-2">
                    <b>{`Image preview`}</b>
                  </h6>
                </div>
              </div>
              <Row>
                <div className="uploaded-images">
                  <div className="d-flex flex-wrap">
                    <div className="image-preview p-2 position-relative" style={{ width: '100px', height: '100px' }}>
                      <img
                        src={`${process.env.REACT_APP_DIGITAL_OCEAN_URL}/${details.file}`}
                        alt="image"
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                      />
                    </div>
                  </div>
                </div>
              </Row>
            </>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AdsDetail;
